export const PRIVILEGE_ALL = 'ALL';
export const PRIVILEGE_CREATE = 'CREATE';
export const PRIVILEGE_READ = 'READ';
export const PRIVILEGE_DELETE = 'DELETE';

export const PRIVILEGE_TO_CREATE = [PRIVILEGE_ALL, PRIVILEGE_CREATE];
export const PRIVILEGE_TO_READ = [PRIVILEGE_ALL, PRIVILEGE_CREATE, PRIVILEGE_READ];
export const PRIVILEGE_TO_DELETE = [PRIVILEGE_ALL, PRIVILEGE_DELETE];


export const E_ACCOUNT = 'ACCOUNT';
export const E_USER = 'USER';
export const E_ADVERTISER = 'ADVERTISER';
export const E_RATECARD = 'RATECARD';
export const E_ORGANIZATION = 'ORGANIZATION';
